<template>
	<div>
		<div class="xqlist" style="min-height:740px;">
			   <div class="liebiao1" v-for="(g) in list" :key="item" @click="datails(g.d_id)">
					<div class="title">
						<h4 class="titleh4">{{g.demand.name}}</h4>
						<span v-if="g.demand.status==1" style="color:#4DC800;">报价中</span>
						<span v-if="g.demand.status==0">审核中</span>
						<span v-if="g.demand.status==-1" style="color:#666666;">已驳回</span>
						<span v-if="g.demand.status==2 && g.demand.is_off==0">已结束</span>
						<span v-if="g.demand.status==2 && g.demand.is_off==1" style="color: #FF0000;">平台下架</span>
						
					</div>
					<div class="titleTiem">
						<img src="@/assets/tiem.png" alt="" srcset="" />
						<span>邀标时间：{{g.create_time}}</span>
					</div>
					<div class="hylist">
						<div v-for="(i,index) in g.demand.industries" :key="index" >{{i}}</div>
					</div>
					<div class="hybox">
						<span>{{g.demand.description}}</span>
					</div>
					<div class="ybuser">
						<img :src="g.user.avatar" alt="" srcset="" class="ybarter" />
						<div class="ybox">
							<div class="yboxTitle">
								<div>{{g.user.nickname}}</div>
								<span style="color: #1E3A8A;" v-if="g.is_quote==1 && g.status==1">已参与</span>
								<span style="color: #FF0000;" v-if="g.is_quote==0 && g.status==-1">已拒绝</span>
								<!-- <span v-else>报价剩余：3天24时59分</span> -->
							<!-- 	<span style="color: #FF0000;">超时拒绝</span> -->
							<p v-if="g.is_quote==0 && g.status==0 && g.is_timeout==0">
								<span>报价截止时间:</span>
								<CountDown :endTime="g.display_end_time*1000"/>
							</p>
							
							</div>
							<div class="yboxNumber">
								<div class="yboxNumberImg">
									<img src="@/assets/pj5.png" mode="" v-if="g.user.display_score==5"></img>
									<img src="@/assets/pj4.png" mode="" v-if="g.user.display_score>=4 && g.user.display_score<5"></img>
									<img src="@/assets/pj3.png" mode="" v-if="g.user.display_score>=3 && g.user.display_score<4"></img>
									<img src="@/assets/pj2.png" mode="" v-if="g.user.display_score>=2 && g.user.display_score<3"></img>
									<img src="@/assets/pj1.png" mode="" v-if="g.user.display_score>=1 && g.user.display_score<2"></img>
									<div v-if="g.user.display_score==0" style="font-size:20rpx;margin-right:5rpx;">暂无评分</div>
									<span>{{g.user.display_score}}</span>
								</div>
								<el-divider direction="vertical"></el-divider>
								<p>订单数量：<span>{{g.user.total_order_num}}</span></p>
								<el-divider direction="vertical"></el-divider>
								<p>售后：<span>{{g.user.aftersale_num}}</span></p>
							</div>
						</div>
					</div>
			   </div>
		</div>
	</div>
</template>

<script>
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
	  		CountDown
	  },
	  data() {
	    return {
			
	    }
	  },
	  props:{
		 list:{} 
	  },
	  methods: {
		datails(d_id){
			const targetPath = '/demandHome/demandinvitedList/InvitDatails?d_id='+d_id
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		}
	  },
	}
</script>

<style scoped>
	.xqlist{
			width:1200px;
			margin: 0 auto;
			display:flex;
	/* 		justify-content:space-between; */
			flex-wrap:wrap;
		}
		.xqlist>div:nth-child(3n){
			margin-right:0px;
		}
		.liebiao1{
			width:384px;
			height:223px;
			background: #FFFFFF;
			box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
			border-radius: 12px;
			margin-bottom:24px;
			margin-right:24px;
			padding:12px;
			box-sizing: border-box;
			cursor:pointer;
			transition: all 0.3s;
		}
		.liebiao1:hover{
			transform: scale(1.03);
		}
		.title{
			width:100%;
			display:flex;
			justify-content:space-between;
		}
		.titleh4{
			width:260px;
			overflow: hidden; 
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.title span{
			color:#1E3A8A;
		}
		.titleTiem{
			width:100%;
			display:flex;
			align-items: center;
		}
		.titleTiem img{
			width:12px;
			height:12px;
			margin-right:5px;
		}
		.titleTiem span{
			font-weight: 400;
			font-size: 12px;
			color: #999999;
		}
		.hylist{
			width:100%;
			overflow: hidden;
		}
		.hylist div{
	        padding:3px 5px;
			box-sizing: border-box;
			background: rgba(66,151,255,0.15);
			border-radius: 4px;
			float: left;
			font-weight: 500;
			font-size: 12px;
			color: #4297FF;
			margin-right:6px;
			margin-top:6px;
		}
		.hybox{
			width:100%;
			height:60px;
			margin-top:5px;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
		    word-wrap: break-word;
			text-overflow: ellipsis;
		}
		.ybuser{
			width:100%;
			display:flex;
			align-items: center;
			background: #EFF0F1;
			border-radius: 8px 8px 8px 8px;
			padding:5px;
			box-sizing: border-box;
			margin-top:12px;
		}
		.ybarter{
			width:32px;
			height:32px;
			border-radius:50%;
			margin-right:5px;
		}
		.yboxTitle{
			width:300px;
			display:flex;
			align-items:center;
			justify-content:space-between;
		}
		.yboxTitle span{
			font-weight: 500;
			font-size: 12px;
			color: #FF5900;
		}
		.yboxTitle div{
			width:150px;
			font-weight: 500;
			font-size: 14px;
			color: #333333;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap; 
		}
		.yboxNumber{
			display:flex;
			align-items:center;
			font-weight: 400;
			font-size: 12px;
			color: #666666;
		}
		.yboxNumberImg{
			display:flex;
			align-items:center;
		}
		.yboxNumberImg img{
			width:12px;
			height:12px;
			margin-right:3px;
		}
</style>